import { css as h, LitElement as f, nothing as g, html as u } from "lit";
import { property as a, customElement as b } from "lit/decorators.js";
import { classMap as v } from "lit/directives/class-map.js";
import { b as m, f as y } from "./styles-scZ6dVz-.js";
var x = Object.defineProperty, k = Object.getOwnPropertyDescriptor, n = (e, t, i, l) => {
  for (var r = l > 1 ? void 0 : l ? k(t, i) : t, p = e.length - 1, c; p >= 0; p--)
    (c = e[p]) && (r = (l ? c(t, i, r) : c(r)) || r);
  return l && r && x(t, i, r), r;
};
let s = class extends f {
  constructor() {
    super(...arguments), this.name = "", this.value = "", this.checked = !1, this.disabled = !1, this.required = !1, this.label = "", this.description = "";
  }
  handleChange() {
    this.disabled || (this.checked = !0, this.dispatchEvent(
      new CustomEvent("ark-radio-change", {
        detail: { value: this.value },
        bubbles: !0,
        composed: !0
      })
    ));
  }
  handleClick(e) {
    e.target.tagName !== "INPUT" && this.handleChange();
  }
  render() {
    const e = {
      radio: !0,
      checked: this.checked,
      disabled: this.disabled
    }, t = `radio-${this.value}`;
    return u`
      <label
        part="radio"
        class=${v(e)}
        @click=${this.handleClick}
      >
        <input
          class="input"
          type="radio"
          id=${t}
          name=${this.name}
          .value=${this.value}
          .checked=${this.checked}
          ?disabled=${this.disabled}
          ?required=${this.required}
          @change=${this.handleChange}
          aria-describedby=${this.description ? `${t}-description` : g}
        />
        <span part="control" class="control">
          <span part="indicator" class="indicator"></span>
        </span>
        <span part="label" class="label-wrapper">
          <span part="text" class="text">
            <slot>${this.label}</slot>
          </span>
          ${this.description ? u`
                <span part="description" class="description" id="${t}-description">
                  <slot name="description">${this.description}</slot>
                </span>
              ` : u`<slot name="description"></slot>`}
        </span>
      </label>
    `;
  }
};
s.styles = [
  m,
  y,
  h`
      :host {
        display: inline-block;
      }

      .radio {
        display: inline-flex;
        align-items: flex-start;
        gap: var(--r5-space-2);
        cursor: pointer;
        user-select: none;
      }

      .radio.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }

      .control {
        position: relative;
        flex-shrink: 0;
        width: 1rem;
        height: 1rem;
        margin-top: 0.125rem;
        border: 2px solid var(--r5-border);
        border-radius: var(--r5-radius-full);
        background-color: var(--r5-surface);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .radio:hover:not(.disabled) .control {
        border-color: var(--r5-primary);
      }

      .radio.checked .control {
        border-color: var(--r5-primary);
        background-color: var(--r5-primary);
      }

      .indicator {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0.375rem;
        height: 0.375rem;
        border-radius: var(--r5-radius-full);
        background-color: white;
        transform: translate(-50%, -50%) scale(0);
        transition: transform var(--r5-duration-fast) var(--r5-ease-out);
      }

      .radio.checked .indicator {
        transform: translate(-50%, -50%) scale(1);
      }

      .input {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }

      .input:focus-visible + .control {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
      }

      .label-wrapper {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-0-5);
      }

      .text {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-normal);
        color: var(--r5-text);
        line-height: var(--r5-leading-tight);
      }

      .description {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
        line-height: var(--r5-leading-normal);
      }

      @media (prefers-reduced-motion: reduce) {
        .control,
        .indicator {
          transition: none;
        }
      }
    `
];
n([
  a({ type: String, reflect: !0 })
], s.prototype, "name", 2);
n([
  a({ type: String, reflect: !0 })
], s.prototype, "value", 2);
n([
  a({ type: Boolean, reflect: !0 })
], s.prototype, "checked", 2);
n([
  a({ type: Boolean, reflect: !0 })
], s.prototype, "disabled", 2);
n([
  a({ type: Boolean, reflect: !0 })
], s.prototype, "required", 2);
n([
  a({ type: String })
], s.prototype, "label", 2);
n([
  a({ type: String })
], s.prototype, "description", 2);
s = n([
  b("ark-radio")
], s);
var w = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, d = (e, t, i, l) => {
  for (var r = l > 1 ? void 0 : l ? $(t, i) : t, p = e.length - 1, c; p >= 0; p--)
    (c = e[p]) && (r = (l ? c(t, i, r) : c(r)) || r);
  return l && r && w(t, i, r), r;
};
let o = class extends f {
  constructor() {
    super(...arguments), this.name = "", this.value = "", this.defaultValue = "", this.label = "", this.orientation = "vertical", this.disabled = !1, this.required = !1, this._initialized = !1, this.handleRadioChange = (e) => {
      e.stopPropagation(), this.value = e.detail.value, this.dispatchEvent(
        new CustomEvent("ark-change", {
          detail: { value: this.value },
          bubbles: !0,
          composed: !0
        })
      );
    };
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("ark-radio-change", this.handleRadioChange), this.setAttribute("role", "radiogroup"), this.label && this.setAttribute("aria-label", this.label);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("ark-radio-change", this.handleRadioChange);
  }
  firstUpdated() {
    !this._initialized && this.defaultValue && (this.value = this.defaultValue, this._initialized = !0), this.updateRadios();
  }
  updated(e) {
    (e.has("value") || e.has("disabled") || e.has("name")) && this.updateRadios(), e.has("label") && (this.label ? this.setAttribute("aria-label", this.label) : this.removeAttribute("aria-label"));
  }
  updateRadios() {
    this.querySelectorAll("ark-radio").forEach((t) => {
      const i = t;
      this.name && (i.name = this.name), i.checked = i.value === this.value, this.disabled && (i.disabled = !0);
    });
  }
  render() {
    const e = {
      group: !0,
      [this.orientation]: !0,
      disabled: this.disabled
    };
    return u`
      <div part="group" class=${v(e)}>
        ${this.label ? u`<span part="label" class="label">${this.label}</span>` : null}
        <div class="items">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
o.styles = [
  m,
  h`
      :host {
        display: block;
      }

      .group {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-2);
      }

      .label {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text);
        margin-bottom: var(--r5-space-2);
      }

      .items {
        display: flex;
        gap: var(--r5-space-3);
      }

      .vertical .items {
        flex-direction: column;
      }

      .horizontal .items {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    `
];
d([
  a({ type: String, reflect: !0 })
], o.prototype, "name", 2);
d([
  a({ type: String })
], o.prototype, "value", 2);
d([
  a({ type: String, attribute: "default-value" })
], o.prototype, "defaultValue", 2);
d([
  a({ type: String })
], o.prototype, "label", 2);
d([
  a({ type: String, reflect: !0 })
], o.prototype, "orientation", 2);
d([
  a({ type: Boolean, reflect: !0 })
], o.prototype, "disabled", 2);
d([
  a({ type: Boolean, reflect: !0 })
], o.prototype, "required", 2);
o = d([
  b("ark-radio-group")
], o);
export {
  s as A,
  o as a
};
//# sourceMappingURL=ark-radio-group-CPhPPT-7.js.map
